<ng-container *transloco="let t; prefix: 'new-payment-service'">
  <!-- Create Payment Account modal -->
  <qwiko-modal
    [id]="'new-payment-service'"
    [isFullScreen]="true"
    [isCentered]="true"
  >
    @if (isRecordPayment()) {
      <div
        class="z-50 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div
          class="sticky-nav flex md:hidden justify-start items-center mb-2 w-full"
        >
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="closeModal()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
        </div>
        <div
          class="sticky-nav hidden md:flex justify-end items-center mb-2 w-full"
        >
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="closeModal()"
          >
            <span class="flex items-center gap-1">
              <span class="text-sm font-light mt-[0.1rem]" *transloco="let t">{{
                t("close")
              }}</span>
              <i class="fa-light text-base fa-xmark"></i>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <!-- <img
            class="rounded-full size-20 mx-auto mb-4"
            src="/assets/icons/providers/{{ selectedProvider()?.icon }}"
            alt=""
          /> -->
          <h2 class="text-2xl font-normal text-center w-full mb-2">
            {{ t("new_payment_title") }}
          </h2>
          <!-- <h2 class="text-xl font-normal text-center w-full mb-2">
            {{ selectedProvider()?.display_name }}
          </h2> -->
        </div>
      </div>

      <div class="w-full md:w-8/12 mx-auto max-h-[80vh] px-6 md:px-5 mt-2 mb-6">
        <label for="amount_number_web" class="form-control w-full">
          <div class="label">
            <span class="label-text flex gap-1">
              <span>
                {{ t("add_amount_label") }}
              </span>
              <span
                class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
              ></span>
            </span>
          </div>

          <!-- <button
            type="button"
            [disabled]="loading()"
            (click)="addAmount()"
            class="md:hidden bg-base-200 border-[0.5px] border-gray-500 btn flex flex-row items-center justify-between font-normal h-full md:hover:bg-base-300 md:hover:border-neutral-400 px-4 py-2 rounded-box text-sm text-base-content w-full"
          >
            <div class="flex gap-2 items-center font-semibold">
              <span class="text-base text-neutral-400 mt-1">
                {{ country().currency }}
              </span>
              <span class="mt-1 text-xl">{{ amount() ?? 0 }}</span>
            </div>
            @if (amount()) {
              <i
                class="fa-light fa-pen-to-square text-neutral-500 text-lg mr-1"
              ></i>
            } @else {
              <i class="fa-solid fa-chevron-right text-lg mr-1"></i>
            }
          </button> -->

          <label
            for="amount_number_web"
            class="flex bg-base-100 font-semibold gap-0 h-full input items-center text-xl text-base-content py-2 rounded-box w-full input-bordered"
            [ngClass]="
              (amount() === null || amount() === '0') && amount_number.touched
                ? 'input-error'
                : ''
            "
          >
            <span
              class="text-base mt-1 text-neutral-600 dark:!text-neutral-400"
              >{{ country().currency }}</span
            >
            <input
              type="text"
              class="mt-1 ml-2"
              [ngClass]="
                (amount() === null || amount() === '0') && amount_number.touched
                  ? 'input-error text-error'
                  : ''
              "
              (paste)="formatOnPaste($event)"
              (keyup)="formatAmount($event)"
              #amount_number="ngModel"
              [(ngModel)]="amount"
              [placeholder]="'0'"
              name="amount_number_web"
              inputmode="numeric"
              type="text"
              required
              [disabled]="loading()"
            />
          </label>
          <div
            [ngClass]="
              (amount() === null || amount() === '0') && amount_number.touched
                ? ''
                : 'hidden'
            "
            class="label"
          >
            <span class="label-text-alt text-error">{{
              t("amount_error")
            }}</span>
          </div>
        </label>

        <label class="form-control w-full">
          <div class="label">
            <span class="label-text flex gap-1">
              <span class="label-text">{{ t("payment_accounts_label") }} </span>
              <span
                class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
              ></span>
            </span>
          </div>

          <button
            type="button"
            [disabled]="loading()"
            (click)="choosePaymentAccount()"
            class="bg-base-200 border-[0.5px] border-gray-500 btn flex flex-row items-center justify-between font-normal h-full hover:bg-base-300 hover:border-neutral-400 px-4 py-2 rounded-box text-sm text-base-content w-full"
            [ngClass]="{
              '!pl-2': !paymentAccount(),
            }"
          >
            @if (paymentAccount()) {
              <div class="flex flex-row gap-3 justify-center items-center">
                <div class="rounded-full size-11 bg-neutral-400">
                  <img
                    src="/assets/icons/providers/{{
                      paymentAccount()?.payment_provider?.icon
                    }}"
                    class=""
                    alt=""
                  />
                </div>
                <div class="flex flex-col items-start">
                  <span class="text-base">{{
                    paymentAccount()?.label
                      ? paymentAccount()?.label
                      : paymentAccount()?.name
                  }}</span>
                  <span class="text-neutral-400 mt-1">{{
                    paymentAccount()?.number_display
                  }}</span>
                </div>
              </div>
              <i
                class="fa-light fa-pen-to-square text-neutral-500 text-lg mr-1"
              ></i>
            } @else {
              <div class="flex flex-row gap-3 justify-center items-center">
                <div class="rounded-full size-11 bg-neutral-400">
                  <img
                    class="w-full dark:hidden"
                    src="/assets/logo/qwiko-icon-dark.svg"
                    alt=""
                  />
                  <img
                    class="w-full hidden dark:!flex"
                    src="/assets/logo/qwiko-icon-light.svg"
                    alt=""
                  />
                </div>
                <div class="flex flex-col items-start">
                  <span class="text-base">{{ t("choose_account") }}</span>
                </div>
              </div>
              <i
                class="fa-light fa-pen-to-square text-neutral-500 text-lg mr-1"
              ></i>
            }
          </button>

          @if (paymentAccount()) {
            <label
              class="label cursor-pointer items-center justify-center w-fit ml-auto flex gap-2"
            >
              @if (isDefaultAccount()) {
                <span class="label-text text-xs text-neutral-400">{{
                  t("remove_default")
                }}</span>
              } @else {
                <span class="label-text text-xs text-neutral-400">{{
                  t("set_as_default")
                }}</span>
              }

              <input
                type="checkbox"
                #defaultAccount="ngModel"
                (ngModelChange)="toggleDefaultAccount($event)"
                [ngModel]="isDefaultAccount()"
                class="toggle toggle-xs !toggle-success"
                [checked]="isDefaultAccount() ? 'checked' : ''"
              />
            </label>
          }
        </label>

        <label for="customer_number" class="form-control w-full">
          <div class="label">
            <span class="label-text flex gap-1">
              <span>
                {{ t("customer_number_label") }}
              </span>
              <!-- <span
                class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
              ></span> -->
            </span>
          </div>

          <!-- <button
            type="button"
            [disabled]="loading()"
            (click)="addAmount()"
            class="md:hidden bg-base-200 border-[0.5px] border-gray-500 btn flex flex-row items-center justify-between font-normal h-full md:hover:bg-base-300 md:hover:border-neutral-400 px-4 py-2 rounded-box text-sm text-base-content w-full"
          >
            <div class="flex gap-2 items-center font-semibold">
              <span class="text-base text-neutral-400 mt-1">
                {{ country().currency }}
              </span>
              <span class="mt-1 text-xl">{{ amount() ?? 0 }}</span>
            </div>
            @if (amount()) {
              <i
                class="fa-light fa-pen-to-square text-neutral-500 text-lg mr-1"
              ></i>
            } @else {
              <i class="fa-solid fa-chevron-right text-lg mr-1"></i>
            }
          </button> -->

          <label
            for="customer_number"
            class="flex bg-base-100 font-semibold gap-0 h-full input items-center text-xl text-base-content py-2 rounded-box w-full input-bordered"
          >
            <span class="mt-1 text-neutral-600 dark:!text-neutral-400">{{
              country().phone_code
            }}</span>
            <input
              type="text"
              class="mt-1"
              #customer_number
              (paste)="formatCustomerNumberOnPaste($event)"
              (keyup)="customerNumberChange($event)"
              [(ngModel)]="customerNumber"
              [placeholder]="t('customer_number_placeholder')"
              name="customer_number"
              inputmode="numeric"
              type="tel"
              [disabled]="loading()"
            />
          </label>
        </label>

        <!-- <label class="form-control w-full">
          <div class="label">
            <span class="label-text">{{ t("payment_reason_label") }} </span>
          </div>

          <button
            type="button"
            [disabled]="loading()"
            (click)="choosePaymentAccount()"
            class="bg-base-200 border-[0.5px] border-gray-500 btn flex flex-row items-center justify-between font-normal h-full hover:bg-base-300 hover:border-neutral-400 px-4 py-2 rounded-box text-sm text-base-content w-full"
          >
            @if (paymentAccount()) {
              <span class="mt-1 text-lg">{{
                paymentAccount()?.label || paymentAccount()?.name
              }}</span>
              <i
                class="fa-light fa-pen-to-square text-neutral-500 text-lg mr-1"
              ></i>
            } @else {
              <span class="mt-1 text-lg">{{ t("add_payment_reason") }}</span>
              <i class="fa-solid fa-chevron-right text-lg mr-1"></i>
            }
          </button>
        </label> -->
      </div>

      <div
        class="sticky-footer md:mt-10 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          [disabled]="
            loading() ||
            amount() === null ||
            amount() === '0' ||
            paymentAccount() === null
          "
          type="button"
          class="btn btn-md w-full md:w-8/12 mx-auto btn-primary rounded-box"
          (click)="openQRCode()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <span> {{ t("create_payment") }} </span>
          }
        </button>
      </div>
    }
    @if (isAddAmount()) {
      <div
        class="z-50 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div class="sticky-nav flex justify-start items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="back()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <!-- <img
          class="rounded-full size-20 mx-auto mb-4"
          src="/assets/icons/providers/{{ selectedProvider()?.icon }}"
          alt=""
        /> -->
          <h2 class="text-2xl font-normal text-center w-full mb-2">
            {{ t("add_amount_title") }}
          </h2>
          <!-- <h2 class="text-xl font-normal text-center w-full mb-2">
          {{ selectedProvider()?.display_name }}
        </h2> -->
        </div>
      </div>

      <div
        class="w-full md:w-8/12 mx-auto max-h-[80vh] px-6 md:px-5 mt-4 mb-6 overflow-y-auto"
      >
        <form #addAmountForm="ngForm" class="w-full py-2">
          <!-- @if (alert()) {
               <qwiko-alert [(alert)]="alert"></qwiko-alert>
             } -->
          <label
            class="form-control bg-base-100 flex flex-row justify-center items-center font-semibold gap-2 h-full input focus-within:!outline-none focus-within:!border-none text-3xl py-2 rounded-box w-full relative"
          >
            <span
              #measure
              class="invisible absolute whitespace-pre px-2"
              aria-hidden="true"
            >
              {{ amount() || "0" }}
            </span>
            <input
              type="text"
              [style.width.px]="measureRef()!.nativeElement.offsetWidth"
              class="mt-1 text-right max-w-full transition-all duration-100"
              (paste)="formatOnPaste($event)"
              (keyup)="formatAmount($event)"
              #amount_number
              [(ngModel)]="amount"
              [placeholder]="'0'"
              name="amount_number"
              inputmode="numeric"
              type="tel"
              required
              autofocus
              [disabled]="loading()"
            />
            <span class="text-xl mt-1 text-neutral-400">{{
              country().currency
            }}</span>
            <!-- <div class="flex justify-center items-center w-full"></div> -->
          </label>
        </form>
      </div>

      <div
        class="sticky-footer md:mt-10 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          [disabled]="addAmountForm.invalid || loading()"
          type="button"
          class="btn btn-md w-full md:w-8/12 mx-auto btn-primary rounded-box"
          (click)="back()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <span> {{ t("add_amount") }} </span>
          }
        </button>
      </div>
    }
    @if (isAddCustomer()) {
      <div
        class="z-50 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div class="sticky-nav flex justify-start items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="back()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <!-- <img
          class="rounded-full size-20 mx-auto mb-4"
          src="/assets/icons/providers/{{ selectedProvider()?.icon }}"
          alt=""
        /> -->
          <h2 class="text-2xl font-normal text-center w-full mb-2">
            {{ t("add_customer_title") }}
          </h2>
          <!-- <h2 class="text-xl font-normal text-center w-full mb-2">
          {{ selectedProvider()?.display_name }}
        </h2> -->
        </div>
      </div>

      <div
        class="w-full md:w-8/12 mx-auto max-h-[80vh] px-6 md:px-5 mt-4 mb-6 overflow-y-auto"
      >
        <form #addAmountForm="ngForm" class="w-full py-2">
          <!-- @if (alert()) {
               <qwiko-alert [(alert)]="alert"></qwiko-alert>
             } -->
          <label
            class="form-control bg-base-100 flex flex-row justify-center items-center font-semibold gap-2 h-full input focus-within:!outline-none focus-within:!border-none text-3xl py-2 rounded-box w-full relative"
          >
            <span
              #measure
              class="invisible absolute whitespace-pre px-2"
              aria-hidden="true"
            >
              {{ amount() || "0" }}
            </span>
            <input
              type="text"
              [style.width.px]="measureRef()!.nativeElement.offsetWidth"
              class="mt-1 text-right max-w-full transition-all duration-100"
              (paste)="formatOnPaste($event)"
              (keyup)="formatAmount($event)"
              #amount_number
              [(ngModel)]="amount"
              [placeholder]="'0'"
              name="amount_number"
              inputmode="numeric"
              type="tel"
              required
              autofocus
              [disabled]="loading()"
            />
            <span class="text-xl mt-1 text-neutral-400">{{
              country().currency
            }}</span>
            <!-- <div class="flex justify-center items-center w-full"></div> -->
          </label>
        </form>
      </div>

      <div
        class="sticky-footer md:mt-10 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          [disabled]="addAmountForm.invalid || loading()"
          type="button"
          class="btn btn-md w-full md:w-8/12 mx-auto btn-primary rounded-box"
          (click)="back()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <span> {{ t("add_customer") }} </span>
          }
        </button>
      </div>
    }
    @if (isChoosePaymentAccount()) {
      <div
        class="z-50 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div class="sticky-nav flex justify-start items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="back()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <h2 class="text-2xl font-normal text-left md:text-center w-full mb-2">
            {{ t("payment_accounts_title") }}
          </h2>
          <p class="text-left md:text-center w-full mb-2">
            {{ t("payment_accounts_caption") }}
          </p>
        </div>
      </div>

      <div
        class="w-full md:w-9/12 mx-auto pb-10 md:pb-24 max-h-[75vh] md:max-h-[55vh] px-6 md:px-5 pt-2 overflow-y-auto"
      >
        <!-- <button
            type="button"
            [disabled]="loading()"
            (click)="selectPaymentAccount(null)"
            class="btn flex flex-row justify-between items-center p-3 w-full text-md border-neutral-200 mt-2 rounded-box border shadow text-md text-base-content font-normal bg-base-200 h-auto hover:bg-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:hover:bg-primary dark:hover:text-white"
          >
            <div class="flex flex-row gap-3 justify-center items-center">
              <div class="rounded-full size-11 bg-neutral-400">
                <img
                  class="w-full dark:hidden"
                  src="/assets/logo/qwiko-icon-dark.svg"
                  alt=""
                />
                <img
                  class="w-full hidden dark:!flex"
                  src="/assets/logo/qwiko-icon-light.svg"
                  alt=""
                />
              </div>
              <div class="flex flex-col items-start">
                <span class="text-base">{{ t("any_account") }}</span>
              </div>
            </div>
            <i class="fa-light fa-add text-neutral-500 text-xl mr-1"></i>
          </button> -->
        @for (
          account of businessPaymentAccounts();
          track $index;
          let count = $count
        ) {
          <button
            type="button"
            [disabled]="loading()"
            (click)="selectPaymentAccount(account)"
            class="btn flex flex-row justify-between items-center p-3 w-full text-md border-neutral-200 mt-2 rounded-box border shadow text-md text-base-content font-normal bg-base-200 h-auto hover:md:bg-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:hover:md:bg-primary dark:hover:md:text-white"
          >
            <div class="flex flex-row gap-3 justify-center items-center">
              <div class="rounded-full size-11 bg-neutral-400">
                <img
                  src="/assets/icons/providers/{{
                    account.payment_provider?.icon
                  }}"
                  class=""
                  alt=""
                />
              </div>
              <div class="flex flex-col items-start">
                <span class="text-base">{{
                  account.label ? account.label : account.name
                }}</span>
                <span class="text-neutral-400 mt-1">{{
                  account.number_display
                }}</span>
              </div>
            </div>
            <i class="fa-light fa-add text-neutral-500 text-xl mr-1"></i>
          </button>
        } @empty {
          @if (loading()) {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-neutral-400 text-center my-2"
            >
              <span class="loading loading-spinner w-9"></span>
            </div>
          } @else {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
            >
              <i class="fa-light fa-xmark-to-slot text-lg"></i>
              <p class="text-md mt-1">{{ t("no_payment_accounts") }}</p>
            </div>
          }
        }
      </div>
      <!-- <div
        class="fixed bottom-0 right-0 left-0 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          type="button"
          class="btn btn-md w-full md:w-9/12 mx-auto rounded-box"
          ngClass="{{
            businessPaymentAccounts().length
              ? 'btn-outline btn-ghost'
              : 'btn-primary'
          }}
          "
          (click)="addPaymentAccount()"
        >
          <span class="flex items-center gap-3">
            <i class="fa-light fa-circle-plus text-2xl"></i>
            <span class="text-base mt-1">{{ t("add_payment_method") }}</span>
          </span>
        </button>
      </div> -->
    }

    @if (isAddPaymentReason()) {
      <div
        class="z-50 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div class="sticky-nav flex justify-start items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="back()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <h2 class="text-2xl font-normal text-left md:text-center w-full mb-2">
            {{ t("add_payment_reason") }}
          </h2>
          <p class="text-left md:text-center w-full mb-2">
            {{ t("payment_reason_caption") }}
          </p>
        </div>
      </div>

      <div
        class="w-full md:w-9/12 mx-auto pb-10 md:pb-24 max-h-[75vh] md:max-h-[55vh] px-6 md:px-5 pt-2 overflow-y-auto"
      >
        @for (
          account of businessPaymentAccounts();
          track $index;
          let count = $count
        ) {
          <button
            type="button"
            [disabled]="loading()"
            (click)="selectPaymentAccount(account)"
            class="btn flex flex-row justify-between items-center p-3 w-full text-md border-neutral-200 mt-2 rounded-box border shadow text-md text-base-content font-normal bg-base-200 h-full hover:bg-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:hover:bg-primary dark:hover:text-white"
          >
            <div class="flex flex-row gap-3 justify-center items-center">
              <div class="rounded-full size-11 bg-neutral-400">
                <img
                  src="/assets/icons/providers/{{
                    account.payment_provider?.icon
                  }}"
                  class=""
                  alt=""
                />
              </div>
              <div class="flex flex-col items-start">
                <span class="text-lg">{{
                  account.label ? account.label : account.name
                }}</span>
                <span class="">{{ account.number_display }}</span>
              </div>
            </div>
            <i class="fa-light fa-add text-neutral-500 text-xl mr-1"></i>
          </button>
        } @empty {
          @if (loading()) {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-neutral-400 text-center my-2"
            >
              <span class="loading loading-spinner w-9"></span>
            </div>
          } @else {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
            >
              <i class="fa-light fa-xmark-to-slot text-lg"></i>
              <p class="text-md mt-1">{{ t("no_payment_accounts") }}</p>
            </div>
          }
        }
      </div>
      <!-- <div
        class="fixed md:!sticky bottom-0 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          type="button"
          class="btn btn-md w-full md:w-9/12 mx-auto rounded-box"
          ngClass="{{
            businessPaymentAccounts().length
              ? 'btn-outline btn-ghost'
              : 'btn-primary'
          }}
          "
          (click)="addPaymentAccount()"
        >
          <span class="flex items-center gap-3">
            <i class="fa-light fa-circle-plus text-2xl"></i>
            <span class="text-base mt-1">{{ t("add_payment_method") }}</span>
          </span>
        </button>
      </div> -->
    }

    @if (isQRCode()) {
      <div
        class="z-50 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div class="sticky-nav flex justify-between items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="back()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="openQRCode()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-solid text-xl fa-print-magnifying-glass"></i>
              <span class="text-base mt-1">{{ t("check") }}</span>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <!-- <img
          class="rounded-full size-20 mx-auto mb-4"
          src="/assets/icons/providers/{{ selectedProvider()?.icon }}"
          alt=""
        /> -->
          <!-- @if (paymentAccount()?.code) {
            <h2 class="text-2xl font-normal text-center w-full mb-2">
              {{ t("qrcode_offline_title") }}
            </h2>
            <h2 class="text-base font-normal text-center w-full mb-2">
              {{ t("qrcode_offline_caption") }}
            </h2>
          } @else {
          } -->
          <h2 class="text-xl font-normal text-center w-full mb-2">
            {{ t("qrcode_title") }}
          </h2>
          <!-- <h2 class="text-sm font-normal text-center w-full mb-2">
            {{ t("qrcode_caption") }}
          </h2> -->
        </div>
      </div>

      <div class="w-full md:w-8/12 mx-auto px-6 md:px-5 pb-10 mt-1 mb-6">
        <qwiko-qr-code
          [selectedPaymentAccount]="paymentAccount()"
          [canDownload]="false"
          [hasOfflineToggle]="true"
          [(isOffLineMode)]="isOffLineMode"
          [amount]="amountToSave()"
          [transactionCode]="transaction()?.code || null"
          (addPaymentAccount)="changePaymentAccount($event)"
          (hasCopied)="updateTransaction($event)"
          (hasShared)="updateTransaction($event)"
        ></qwiko-qr-code>
      </div>

      <div
        class="sticky-footer md:mt-10 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          type="button"
          class="btn btn-md w-full md:w-8/12 mx-auto btn-success rounded-box"
          (click)="updateTransaction(true)"
          [disabled]="loading()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <div class="flex w-100 gap-2 justify-center items-center">
              <i class="fa-light fa-circle-plus text-white text-xl"></i>
              <span class="text-white">
                {{ t("save_transaction") }}
              </span>
            </div>
          }
        </button>
        <!-- <button
          type="button"
          class="btn btn-md btn-outline w-full md:w-8/12 mx-auto rounded-box"
          (click)="closeModal()"
          [disabled]="loading()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <span *transloco="let t"> {{ t("close") }} </span>
          }
        </button> -->
      </div>
    }

    @if (isConfirmTransaction()) {
      <div
        class="z-50 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div class="sticky-nav flex justify-between items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="back()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
          <button type="button" class="btn btn-sm btn-ghost rounded-full">
            <span class="flex items-center gap-1">
              <i class="fa-solid text-xl fa-print-magnifying-glass"></i>
              <span class="text-base mt-1">{{ t("check") }}</span>
            </span>
          </button>
        </div>
        <div class="flex flex-col items-center gap-2 w-full px-4 py-2 mx-auto">
          <i class="fa-light fa-question-circle text-success text-6xl"></i>
          <h2 class="text-2xl font-normal text-center w-full mb-2">
            {{ t("confirm_title") }}
          </h2>
        </div>
      </div>

      <div
        class="w-full md:w-8/12 mx-auto max-h-[80vh] px-6 md:px-5 mt-2 mb-6 overflow-y-auto"
      >
        <label for="amount_number_web" class="form-control w-full">
          <div class="label">
            <span class="label-text flex gap-1">
              <span>
                {{ t("add_amount_label") }}
              </span>
              <span
                class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
              ></span>
            </span>
          </div>

          <label
            for="amount_number_web"
            class="flex bg-base-100 font-semibold gap-0 h-full input items-center text-xl py-2 rounded-box w-full border !border-[#d2cecf33] !text-neutral-800 dark:!text-neutral-200"
          >
            <span
              class="text-base mt-1 !text-neutral-800 dark:!text-neutral-200"
              >{{ country().currency }}</span
            >
            <input
              type="text"
              class="mt-1 ml-2"
              [ngModel]="amount()"
              [placeholder]="'0'"
              inputmode="numeric"
              type="tel"
              [disabled]="true"
            />
          </label>
        </label>

        <label
          *ngIf="customerNumber()"
          for="customer_number"
          class="form-control w-full"
        >
          <div class="label">
            <span class="label-text flex gap-1">
              <span>
                {{ t("customer_number_label") }}
              </span>
            </span>
          </div>

          <label
            for="customer_number"
            class="flex bg-base-100 font-semibold gap-0 h-full input items-center text-xl py-2 rounded-box w-full border !border-[#d2cecf33] !text-neutral-800 dark:!text-neutral-200"
          >
            <span class="mt-1 !text-neutral-800 dark:!text-neutral-200">{{
              country().phone_code
            }}</span>
            <input
              type="text"
              class="mt-1"
              [ngModel]="customerNumber()"
              [placeholder]="t('customer_number_placeholder')"
              inputmode="numeric"
              type="tel"
              [disabled]="true"
            />
          </label>
        </label>

        <label class="form-control w-full">
          <div class="label">
            <span class="label-text">{{ t("into_account") }} </span>
          </div>
          <button
            type="button"
            class="bg-base-200 border-[0.5px] border-gray-500 btn flex flex-row items-center justify-between font-normal h-auto hover:bg-base-300 hover:border-neutral-400 px-4 py-2 rounded-box text-sm text-base-content w-full"
            [ngClass]="{
              '!pl-2': !paymentAccount(),
            }"
          >
            @if (paymentAccount()) {
              <div class="flex flex-row gap-3 justify-center items-center">
                <div class="rounded-full size-11 bg-neutral-400">
                  <img
                    src="/assets/icons/providers/{{
                      paymentAccount()?.payment_provider?.icon
                    }}"
                    class=""
                    alt=""
                  />
                </div>
                <div class="flex flex-col items-start">
                  <span class="text-base">{{
                    paymentAccount()?.label
                      ? paymentAccount()?.label
                      : paymentAccount()?.name
                  }}</span>
                  <span class="text-neutral-400 mt-1">{{
                    paymentAccount()?.number_display
                  }}</span>
                </div>
              </div>
              <!-- <i
                  class="fa-light fa-pen-to-square text-neutral-500 text-lg mr-1"
                ></i> -->
            } @else {
              <div class="flex flex-row gap-3 justify-center items-center">
                <div class="rounded-full size-11 bg-neutral-400">
                  <img
                    class="w-full dark:hidden"
                    src="/assets/logo/qwiko-icon-dark.svg"
                    alt=""
                  />
                  <img
                    class="w-full hidden dark:!flex"
                    src="/assets/logo/qwiko-icon-light.svg"
                    alt=""
                  />
                </div>
                <div class="flex flex-col items-start">
                  <span class="text-base">{{ t("any_account") }}</span>
                </div>
              </div>
              <i
                class="fa-light fa-pen-to-square text-neutral-500 text-lg mr-1"
              ></i>
            }
          </button>
        </label>
      </div>

      <div
        class="sticky-footer md:mt-10 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          *ngIf="this.paymentAccount()"
          type="button"
          class="btn btn-md w-full md:w-8/12 mx-auto btn-success rounded-box"
          (click)="confirmTransaction()"
          [disabled]="loading()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <div class="flex w-100 gap-2 justify-center items-center">
              <i class="fa-solid fa-circle-check text-white text-xl"></i>
              <span class="text-white">
                {{ t("confirm_transaction") }}
              </span>
            </div>
          }
        </button>
        <!-- <button
        type="button"
        class="btn btn-md btn-outline w-full md:w-8/12 mx-auto rounded-box"
        (click)="closeModal()"
      >
        @if (loading()) {
          <span class="loading loading-spinner"></span>
        } @else {
          <span> {{ t("cancel_transaction") }} </span>
        }
      </button> -->
        <button
          type="button"
          class="btn btn-md btn-outline w-full md:w-8/12 mx-auto rounded-box"
          (click)="closeModal()"
          [disabled]="loading()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <span *transloco="let t"> {{ t("close") }} </span>
          }
        </button>
      </div>
    }
  </qwiko-modal>
</ng-container>
